;(function() {
  /**
   * Align full-screen #menu under the real sticky header.
   *
   * Campaign alternate design v1 shows head__top + head__bottom;
   * use #head's viewport bottom as top inset.
   */
  function syncMenuInsetFromHead() {
    const head = document.getElementById("head")
    if (!head) {
      return
    }
    const bottom = Math.floor(head.getBoundingClientRect().bottom)
    document.documentElement.style.setProperty(
      "--sit-menu-inset-top",
      `${bottom}px`
    )
  }

  function bindMenuInsetSync() {
    syncMenuInsetFromHead()
    window.addEventListener("resize", syncMenuInsetFromHead, { passive: true })
    if (typeof ResizeObserver !== "undefined") {
      const head = document.getElementById("head")
      if (head) {
        new ResizeObserver(syncMenuInsetFromHead).observe(head)
      }
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", bindMenuInsetSync)
  } else {
    bindMenuInsetSync()
  }

  class Menu {
    constructor(
      el = null,
      options = {
        overlaySelector: ".menu__overlay",
        navSelector: ".menu__nav",
        buttonSelector: ".menu-button",
        redesignButtonSelector: ".redesign-mobile-menu__button"  // Add new selector
      }
    ) {
      this.el = el
      this.options = options
      if (this.el) {
        this.init()
        return
      }
      throw new Error(`${this.selector} not found in DOM.`)
    }

    init() {
      if (!this.el.hasAttribute("data-active")) {
        this.el.setAttribute("data-active", "false")
      }
      this.overlay =
        this.el.querySelector(this.options.overlaySelector) || false
      this.nav = this.el.querySelector(this.options.navSelector) || false
      this.buttons =
        [...document.querySelectorAll(this.options.buttonSelector)] || false
      this.redesignButton =
        document.querySelector(this.options.redesignButtonSelector) || false
      if (this.overlay && this.nav && this.buttons) {
        this.handleButtonClick()
        this.handleOverlayClick()
        this.initAnimTimeline()
      }
    }

    initAnimTimeline() {
      const isDefaultSite = document.body.classList.contains('site--default');
      const hasClusterClass = document.body.className.includes('cluster');
      const isAOSite = document.body.classList.contains('site--ao');

      if ((isDefaultSite && !hasClusterClass) || isAOSite) {
        const timeline = gsap.timeline({
          paused: true
        })

        const reverseTimeline = gsap.timeline({
          paused: true
        })

        gsap.set(this.el, { visibility: "hidden" })
        gsap.set(this.overlay, { opacity: 0 })
        gsap.set(this.nav, { top: '-100%' })  // Changed from yPercent
        gsap.set(this.redesignButton, { opacity: 0, visibility: "hidden" })

        timeline
          .to(this.el, { duration: 0, visibility: "visible" })
          .to(this.nav, {
            duration: 1.2,
            top: '2%',  // Changed from yPercent
            ease: "power2.inOut"
          })
          .to(this.nav, {
            duration: 2,
            top: '0%',  // Changed from yPercent
            ease: "elastic.out(0.3, 0.2)"
          })
          .to(
            this.overlay,
            {
              duration: 0.8,
              opacity: 1,
            },
            "-=2"
          )
          .to(this.redesignButton, {
            duration: 0.3, // Quicken fade in
            opacity: 1,
            visibility: "visible"
          }, "-=2") // Start 1.5s before menu animation ends instead of 0.5s

        reverseTimeline
          .to(this.redesignButton, {
            duration: 0,
            opacity: 0,
            visibility: "hidden"
          })
          .to(this.nav, {
            duration: 1.4,
            top: '-100%',  // Changed from yPercent
            ease: "power4.inOut"
          })
          .to(
            this.overlay,
            {
              duration: 1,
              opacity: 0,
            },
            "-=1"
          )
          .set(this.el, { visibility: "hidden" })

        this.animTimeline = timeline
        this.reverseTimeline = reverseTimeline
      } else {
        // Original right-to-left animation
        const timeline = gsap.timeline({
          paused: true
        })
        gsap.set(this.el, { visibility: "hidden" })
        gsap.set(this.overlay, { opacity: 0 })
        gsap.set(this.nav, { xPercent: 100 })  // Restore xPercent
        gsap.set(this.redesignButton, { opacity: 0, visibility: "hidden" })

        timeline
          .to(this.el, { duration: 0, visibility: "visible" })
          .to(this.nav, {
            duration: 0.25,
            xPercent: 0,  // Restore xPercent
            ease: "power2.inOut"
          })
          .to(
            this.overlay,
            {
              duration: 0.15,
              opacity: 1,
            },
            "-=0.1"
          )
          .to(this.redesignButton, {
            duration: 0.3,
            opacity: 1,
            visibility: "visible"
          }, "-=0.15")

        this.animTimeline = timeline
        this.reverseTimeline = null
      }
    }

    handleButtonClick() {
      this.buttons.forEach(button => {
        button.addEventListener("click", e => {
          e.preventDefault()
          const active = e.currentTarget.getAttribute("data-active") === "true"
          this.toggle(active)
        })
      })
    }

    handleOverlayClick() {
      this.overlay.addEventListener("click", () => {
        this.toggle(true)
      })
    }

    toggle(active) {
      const isDefaultSite = document.body.classList.contains('site--default');
      const hasClusterClass = document.body.className.includes('cluster');
      const isAOSite = document.body.classList.contains('site--ao');
      const useNewAnimation = (isDefaultSite && !hasClusterClass) || isAOSite;

      if (!active) {
        this.buttons.forEach(button =>
          button.setAttribute("data-active", "true")
        )
        this.el.setAttribute("data-active", "true")
        syncMenuInsetFromHead()
        if (useNewAnimation) {
          this.reverseTimeline?.pause(0)
          this.animTimeline.progress(0)
        }
        this.animTimeline.play()
        return
      } else {
        if (this.redesignButton) {
          gsap.set(this.redesignButton, { opacity: 0, visibility: "hidden" })
        }
      }
      this.buttons.forEach(button =>
        button.setAttribute("data-active", "false")
      )
      this.el.setAttribute("data-active", "false")
      if (useNewAnimation && this.reverseTimeline) {
        this.animTimeline.pause()
        this.reverseTimeline.progress(0)
        this.reverseTimeline.play()
      } else {
        this.animTimeline.reverse()
      }
    }
  }

  function initMenu(selector = "#menu") {
    const el = document.querySelector(selector)
    el && new Menu(el)
  }

  initMenu()
})()
